var core = require('./core_last.js');

$(document).ready(function () {
    $('body,html').animate({
        scrollTop: 0
    }, 400);

    $('form').submit(function (e) {
        getTurn(e);
    });

    $('#search_turn_btn').on('click', function (e) {
        getTurn(e);
    });

    $('.cancel-search').on('click', function (e) {
        $('input[name="turnCaption"]').val('');

        let arr = ['has_result', 'has_message', 'has_error'];

        arr.forEach((value) => {
            $('#' + value).removeClass('show').addClass('fade');
        });
    });

});

function getTurn(e) {
    e.preventDefault();
    var sendObj = {};

    sendObj.turnCaption = $('input[name="turnCaption"]').val();

    core.startLoadingAnimation();
    core.sentAjaxTo('GetTurn', sendObj);
}

function showObj(obj) {

    let arr = ['has_result', 'has_message', 'has_error'];

    arr.forEach((value) => {
        if (value === obj)
            $('#' + obj).removeClass('fade').addClass('show');
        else
            $('#' + value).removeClass('show').addClass('fade');
    });
}

export function setResult(resp) {
    if (resp === null || resp === undefined) {
        $('.message').text('К сожаленю произошла ошибка получения данных с сервера.');
        showObj('has_error');
        return;
    }

    if (resp.HasError) {
        $('.message').text(resp.ErrorMessage);
        showObj('has_error');
        return;
    }

    if (resp.ErrorMessage) {
        $('.message').text(resp.ErrorMessage);
        showObj('has_message');
        return;
    }

    let res = resp.Result;
    showObj('has_result');

    $.each(res, (key, value) => {
        let tmp = $('.form-free').find('#' + key);
        if (tmp.length == 0)
            $(tmp).hide();
        else
            if (key === 'dateregoszn')
                value = new Date(value).toLocaleDateString();
        $('#' + key + '_').text(value);
    });
}